<template>
  <div class="agreement-box-wrapper">
    <template v-if="agreements && agreements.length > 0">
      <div class="box-wrapper">
        <agreement-card
          :key="i"
          v-for="(agreement, i) in agreements"
          :data="agreement"
          :type="type"
          :button-text="buttonText"
        >
          <template v-if="type === 'finish'" #default="{ agreement }">
            <p>公司负责人：{{ agreement.submitName || '公司负责人' }}</p>
            <p>签署时间：{{ formatDatetime(agreement.signTime) }}</p>
            <p>签署IP：{{ agreement.ip || '暂无法获取' }}</p>
          </template>
        </agreement-card>
      </div>
      <div class="pagination">
        <el-pagination
          layout="prev, pager, next"
          @current-change="pageNo => $emit('change-page', pageNo, type)"
          :current-page="currentPageNo"
          :total="total"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </template>
    <template v-else>
      <div class="empty"></div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { Pagination } from 'element-ui';
import dayjs from 'dayjs';
import agreementCard from './agreementCard';

Vue.use(Pagination);

const buttonTextMap = {
  wait: '立即签署',
  finish: '查看协议内容'
};

export default {
  name: 'agreementBox',
  components: {
    agreementCard
  },
  props: {
    agreements: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'wait'
    },
    total: {
      type: Number
    },
    pageSize: {
      type: Number
    },
    currentPageNo: {
      type: Number
    }
  },
  computed: {
    buttonText() {
      return buttonTextMap[this.type];
    }
  },
  methods: {
    formatDatetime(datetime) {
      return dayjs(datetime).format('YYYY/MM/DD HH:mm:ss');
    }
  }
};
</script>

<style lang="scss" scoped>
.agreement-box-wrapper {
  display: flex;
  flex-wrap: wrap;

  .box-wrapper {
    display: flex;
    flex-wrap: wrap;
  }

  .pagination {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .empty {
    width: 100%;
    height: 452px;
    background-size: 272px;
    background-position: center center;
    background-image: url('../../../../assets/img/empty.jpg');
    background-repeat: no-repeat;
  }
}
</style>
